import type { AttendanceStatus } from '@/api/attendance'

/**
 * 화면 표시용 출결 상태. 오늘 출결 기록이 없는 상태(NONE·null)는 '하원'으로 표시한다.
 * NONE과 OUT을 구분해야 하는 판정(예: handheldListStatus)에는 원본 값을 쓴다.
 */
export function displayAttendanceStatus(status: AttendanceStatus | 'NONE' | null | undefined): AttendanceStatus {
  return !status || status === 'NONE' ? 'OUT' : status
}
